import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import type { ForvaltningsExtent, TranslatedFeatureResult } from '../api/types';

export interface MapPreview {
    /** Beskrivende tittel, f.eks. datasettnavn eller kobling-navn. */
    title: string;
    result: TranslatedFeatureResult;
    /** Valgfri datasett-extent for zoom når features mangler geometri. */
    extent?: ForvaltningsExtent | null;
    wkid?: number | null;
}

interface MapPreviewContextValue {
    preview: MapPreview | null;
    setPreview: (preview: MapPreview | null) => void;
    clearPreview: () => void;
}

const MapPreviewContext = createContext<MapPreviewContextValue | null>(null);

export const MapPreviewProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [preview, setPreview] = useState<MapPreview | null>(null);
    const clearPreview = useCallback(() => setPreview(null), []);

    const value = useMemo(
        () => ({ preview, setPreview, clearPreview }),
        [preview, clearPreview],
    );

    return <MapPreviewContext.Provider value={value}>{children}</MapPreviewContext.Provider>;
};

export function useMapPreview(): MapPreviewContextValue {
    const ctx = useContext(MapPreviewContext);
    if (!ctx) throw new Error('useMapPreview må brukes innenfor <MapPreviewProvider>');
    return ctx;
}
